function printArticle() {
  const el = document.querySelector(".blog-main-article__inner-content");
  const review = document.querySelector(".blog-medic-review__inner");
  if (!el) return;

  const printWindow = window.open("", "", "width=900,height=700");
  const doc = printWindow.document;

  const html = `
        <!DOCTYPE html>
        <html lang="pt-BR">
            <head>
                <meta charset="UTF-8">
                <title>${document.title}</title>
                <style>
                @page { margin: 12mm; }
                body {
                    font-family: system-ui, sans-serif;
                    color: #111;
                    background: #fff;
                    margin: 0;
                }
                .print-wrap {
                    max-width: 800px;
                    margin: 0 auto;
                    padding: 20px;
                }
                .sidebar_revisor,
                .blog-main-article__inner-content-sidebar,
                .blog-medic-review_side{
                    display: none;
                }
                </style>
            </head>
            <body>
                <div class="print-wrap">
                ${el.innerHTML}
                ${review.innerHTML}
                </div>
            <\/body>
        </html>
    `;

  doc.open();
  doc.write(html);
  doc.close();

  printWindow.focus();
  printWindow.print();
  printWindow.close();
}

function shareByEmail(title, shopUrl, articleUrl) {
  const subject = encodeURIComponent(title);
  const body = encodeURIComponent(
    `Oi! 👋\n\nAchei este artigo interessante e quis te enviar:\n\n${title}\n${shopUrl}${articleUrl}\n\nDá uma olhada!`
  );

  window.location.href = `mailto:?subject=${subject}&body=${body}`;
}

function shareOnFacebook(articleUrl) {
  const url = encodeURIComponent(articleUrl);
  const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
  window.open(shareUrl, "_blank", "width=800,height=600");
}

function shareOnTwitter(articleTitle, articleUrl) {
  const text = encodeURIComponent(articleTitle);
  const url = encodeURIComponent(articleUrl);
  const shareUrl = `https://twitter.com/intent/tweet?text=${text}&url=${url}`;
  window.open(shareUrl, "_blank", "width=800,height=600");
}

function createTimeline() {
  const timelineData = document.querySelector(
    '.blog-medic-review_left input[type="hidden"]'
  ).value;

  if (timelineData) {
    const timeline = JSON.parse(timelineData);
    const timelineContainer = document.querySelector("#rt-timeline");
    if (timeline && timeline.length && timelineContainer) {
      timeline.forEach((item) => {
        const { data, edicao_copia_por, editado_por, escrito_por } = item;

        if (data) {
          const dateRow = document.createElement("div");
          dateRow.className = "rt__row rt__row--date";
          dateRow.innerHTML = `<h4 class="rt__date">${data || ""}</h4>`;
          timelineContainer.appendChild(dateRow);

          if (escrito_por) {
            const escritoRow = document.createElement("div");
            escritoRow.className = "rt__row rt__row--item";
            escritoRow.innerHTML = `
                <div class="rt__label">Escrito Por</div>
                <div class="rt__person">${escrito_por}</div>
              `;
            timelineContainer.appendChild(escritoRow);
          }

          if (editado_por) {
            const editadoRow = document.createElement("div");
            editadoRow.className = "rt__row rt__row--item";
            editadoRow.innerHTML = `
                <div class="rt__label">Editado Por</div>
                <div class="rt__person">${editado_por}</div>
              `;
            timelineContainer.appendChild(editadoRow);
          }

          if (edicao_copia_por) {
            const copiaRow = document.createElement("div");
            copiaRow.className = "rt__row rt__row--item";
            copiaRow.innerHTML = `
                <div class="rt__label">Edição de Cópia Por</div>
                <div class="rt__person">${edicao_copia_por}</div>
              `;
            timelineContainer.appendChild(copiaRow);
          }
        }
      });

      document.querySelector(".rt").classList.remove("hidden");
    }
  }
}

createTimeline();
